import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { IState } from '../graphql/types';
import { giideListPaginationPage } from '../types';
import { setGiidePaginationPage } from '../actions';
import { ITEMS_PER_PAGE } from '../components/utils';
import useGiideList from './useQuery/useGiideList';
import styles from './Hooks.module.css';

const useGiideListPagination = () => {
  const dispatch = useDispatch();
  const paginationPage = useSelector<
    IState,
    giideListPaginationPage | undefined
  >(state => state.giideListPaginationPage);
  const { filteredData } = useGiideList(true);

  const handlePageChange = React.useCallback(
    page => {
      if (page <= 1) {
        dispatch(
          setGiidePaginationPage({
            page,
            paginationState: { minValue: 0, maxValue: ITEMS_PER_PAGE },
          })
        );
      } else {
        dispatch(
          setGiidePaginationPage({
            page,
            paginationState: {
              minValue: page * ITEMS_PER_PAGE - ITEMS_PER_PAGE,
              maxValue: page * ITEMS_PER_PAGE,
            },
          })
        );
      }
    },
    [dispatch]
  );

  const paginationButtonsRender = React.useCallback(
    (_, type, originalElement) => {
      if (type === 'prev') {
        return (
          <span
            className={`${
              paginationPage!.paginationState.minValue !== 0
                ? styles.paginationControl
                : styles.paginationControlPlaceholder
            }`}
          >
            Previous
          </span>
        );
      }
      const dataLength = filteredData ? filteredData.length : 0;
      if (type === 'next') {
        return (
          <span
            className={`${
              paginationPage!.paginationState.maxValue < dataLength
                ? styles.paginationControl
                : styles.paginationControlPlaceholder
            }`}
          >
            Next
          </span>
        );
      }
      return originalElement;
    },
    [paginationPage, filteredData]
  );

  return { paginationPage, handlePageChange, paginationButtonsRender };
};

export default useGiideListPagination;
